import axios from "axios";
import Comment, { CommentType, CommentSummary } from "@/features/Comments/Comment";
import CommentRequestModel, { CommentContainer, ScoreCommentRequestModel, IncidentCommentRequestModel } from "@/features/Comments/CommentRequestModel";

export class CommentService {
    private commentURL = "/api/v1/comments";

    async getCommentsFromServer(type: CommentType, parentID: string): Promise<Comment[]> {
        const response = await axios.get(this.commentURL + "/" + type.toString() + "/" + parentID);
        return response.data as Comment[];
    }

    async createComment(comment: CommentRequestModel): Promise<Comment> {
        const commentContainer = new CommentContainer();
        switch (comment.commentType) {
            case CommentType.ScoreComment:
                commentContainer.scoreComment = comment as ScoreCommentRequestModel;
                break;
            case CommentType.IncidentComment:
                commentContainer.incidentComment = comment as IncidentCommentRequestModel;
                break;
            default:
                throw new Error("createComment is not implemented for comments of this type");
        }
        const response = await axios.post(this.commentURL + `/${comment.commentType.toString()}`, commentContainer);

        return response.data;
    }

    async updateComment(comment: CommentRequestModel): Promise<string> {
        const response = await axios.put(this.commentURL + "/" + comment.id, comment);

        return response.data;
    }

    async deleteComment(id: string): Promise<void> {
        await axios.delete(this.commentURL + "/" + id);
    }

    async getCommentSummaries(type: CommentType, parentID: string): Promise<CommentSummary[]> {
        const response = await axios.get(this.commentURL + "/" + type.toString() + "/" + parentID + "/summaries");

        return response.data as CommentSummary[];
    }
}
